import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=b91d2d24&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=b91d2d24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91d2d24",
  null
  
)

export default component.exports